import {get} from './fetch'
import {NUMBER_OF_FEATURED_REVIEWS} from '../const'
import services from '../config/services'

// http://apidocs.yotpo.com/reference
export const yotpoServiceUrl = (id) =>
  `https://api.yotpo.com/v1/widget/${services.YOTPO_API_KEY}/products/${id}/reviews.json` +
  `?page=1&per_page=${NUMBER_OF_FEATURED_REVIEWS}`

// /////////////////////////////////////////////
// ///// PRODUCT REVIEWS SERVICE ///////////////
// /////////////////////////////////////////////

/**
 * Get all reviews for a product
 *
 * @param {string} productSlug The slug of the product we want reviews for
 * @returns {Object} A response object
 * @todo Camel-case this response and update the reducers/components that ingest it.
 */
export const getAllReviews = (productSlug) =>
  get(`${services.PRODUCT_REVIEW_SERVICE_URL}/reviews/${productSlug}`)

// ///////////////////////////////////////
// ///// YOTPO REVIEWS API ///////////////
// ///////////////////////////////////////

/**
 * Get the featured reviews to display at the bottom of the PDP page.
 *
 * @param {string} productId The product to fetch featured reviews for
 * @returns {Object} A response object
 * @todo Camel-case this response and update the reducers/components that ingest it.
 */
export const getFeaturedReviews = (productId) => get(yotpoServiceUrl(productId))
